import { useState, useCallback, useEffect } from 'react';
import axios from 'axios';
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function RecentAlerts() {
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchAlerts = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/transactions?status=flagged&limit=5`);
      setAlerts(res.data);
    } catch (e) {
      if (process.env.NODE_ENV === 'development') {
        console.error('Failed to fetch alerts:', e);
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAlerts();
    const interval = setInterval(fetchAlerts, 10000);
    return () => clearInterval(interval);
  }, [fetchAlerts]);

  if (loading) return null;
  if (alerts.length === 0) return null;

  return (
    <Card className="p-4 bg-white border border-zinc-200 rounded-xl mb-8" data-testid="recent-alerts">
      <h3 className="text-lg font-bold tracking-tight text-zinc-950 mb-3">
        Recent Flagged Transactions
      </h3>
      <div className="space-y-3">
        {alerts.slice(0, 3).map((txn) => (
          <div key={txn.transaction_id} className="p-3 bg-amber-50 border border-amber-200 rounded-lg">
            <div className="flex justify-between items-start mb-2">
              <div>
                <span className="text-sm font-semibold text-zinc-900">${txn.amount?.toFixed(2)}</span>
                <span className="text-xs text-zinc-500 ml-2">{txn.merchant}</span>
              </div>
              <Badge variant="outline" className="bg-amber-100 text-amber-700 border-amber-300 text-[10px]">
                Score: {(txn.fraud_score * 100).toFixed(0)}%
              </Badge>
            </div>
            {txn.explanation && txn.explanation.length > 0 && (
              <div className="mt-2 pt-2 border-t border-amber-200">
                <p className="text-[10px] font-semibold text-amber-800 mb-1">Why flagged:</p>
                <div className="flex flex-wrap gap-1">
                  {txn.explanation.slice(0, 3).map((exp) => (
                    <span 
                      key={`${txn.transaction_id}-${exp.feature}`} 
                      className={`text-[10px] px-2 py-0.5 rounded-full ${
                        exp.impact === 'increases' 
                          ? 'bg-red-100 text-red-700' 
                          : 'bg-green-100 text-green-700'
                      }`}
                    >
                      {exp.feature}: {exp.value} ({exp.impact === 'increases' ? '↑' : '↓'} {(exp.importance * 100).toFixed(0)}%)
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </Card>
  );
}
